<template>
  <e-dialog
    :dialogTitle="'产品目录'"
    :centerDialogVisible="classifyVisible"
    @updateVisible="classifyResetPopupData"
    @resetPopupData="classifyResetPopupData"
    @submitPopupData="classifySubmitPopupData"
    :popupWidth="'500px'"
    :destroyClose="true"
    :modalAppendToBody="false"
     :showBtn="false"
    :showCloseBtn="true"
  >
    <!-- <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input> -->

    <div class="tree-box">
       <el-tree
      v-loading="loading"
      ref="tree"
      @check="handleCheck"
      :data="categoryTreeData"
      @check-change="handleCheckChange"
      highlight-current
      :props="defaultProps"
      :indent="30"
      :filter-node-method="filterTreeNode"
      :default-checked-keys="defaultCheckedKeys"
      :default-expanded-keys="defaultCheckedKeys"
      node-key="categoryId"
    >
      <template slot-scope="{ node, data }">
        <div style="width: 100%; display: flex">
          <span>{{ data.categoryName }}</span>
        </div>
      </template>
    </el-tree>
    </div>

  </e-dialog>
</template>

<script>
import eDialog from '../../../../../components/common/epecDialog'
export default {
  components: { eDialog },
  props: {
    classifyVisible: {
      type: Boolean,
      default: false
    },
    defaultCheckedKeys: {
      type: Array,
      default() {
        return []
      }
    },
    categoryTreeData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    categoryTreeData(val) {
      console.log(val)
      if (val.length>=0) {
        this.loading = false
      }
    }
  },
  data() {
    return {
      filterText: '',
      loading: true,
      checkNodes: [],
      checkNodes2: [],
      categoryId: null,
      defaultProps: {
        label: 'categoryName',
        isLeaf: 'leafFlag',
        children: 'children'
      },
      checkFlag: false,
      checkCategoryIdList: []
    }
  },
  methods: {
    // 关闭所属分类弹框
    classifyResetPopupData() {
      this.checkCategoryIdList = []
      this.$emit('resetPopupData')
    },

    // 所属分类确定
    classifySubmitPopupData() {

      this.$emit('submitPopupData')
    },


    handleCheckChange(data, flag) {
      if (flag) {
        this.checkNodes.push(data)
        this.checkNodes2.push(data)
      } else {
        this.checkNodes.forEach((item, index) => {
          if (item.categoryId == data.categoryId) {
            this.checkNodes.splice(index, 1)
          }
        })
        this.checkNodes2.forEach((item, index) => {
          if (item.categoryId == data.categoryId) {
            this.checkNodes.splice(index, 1)
          }
        })
      }
    },

    // 勾选树节点
    async handleCheck(data, nodes) {
      this.checkNodes2 = nodes.checkedNodes.filter((item) => item.leafFlag)
      if (!this.checkCategoryIdList.includes(data.categoryId)) {
        this.checkFlag = true
        this.checkCategoryIdList.push(data.categoryId)
        let node = this.$refs.tree.getNode(data.categoryId)
        // 设置未进行的懒加载状态
        node.loaded = false
        // 重新展开节点就会间接出发load达到刷新效果
        node.expand()
      }
    },

    filterTreeNode(value, data) {
      if (!value) return true
      return data.categoryName.indexOf(value) !== -1
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__footer {
  padding: 20px;
}
::v-deep .el-dialog__body {
  height: 312px;
  overflow-y: auto;
  padding-bottom: 0;
}
.tree-box{
  width: 100%;
  height: 250px;
  box-sizing: border-box;
  padding: 2px 0;
  overflow-y: auto;
  margin-top: 10px;
}
</style>
